var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container block-social-icons margin-both-lg"},[_c('h2',{staticClass:"titler margin-bottom-lg"},[_vm._v("Følg oss!")]),_c('SocialLinks',{attrs:{"caption":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }